import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import * as _ from 'lodash';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-perf-overall',
  templateUrl: './perf-overall.component.pug',
  styleUrls: ['./perf-overall.component.scss'],
  standalone: false
})
export class PerfOverallComponent implements OnInit, OnChanges {

  @Input() perfMetrics!: any;
  @Input() selectedTab!: 'exits' | 'pulses';
  data = '-';

  constructor() {

  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.perfMetrics.overall) {
      this.data = String(Math.round((((9 * (this.perfMetrics.overall - 1)) / 4) + 1) * 10) / 10);
    } else {
      let d = _.meanBy(this.perfMetrics, (d: any) => Math.round((((9 * (d['value'] - 1)) / 4) + 1) * 10)) / 10;
      if (Number.isNaN(d)) {
        this.data = '-';
      } else {
        this.data = String(Math.round(d * 10) / 10);
      }
    }
  }
}
